module.exports = __webpack_public_path__ + "img/pay1.2ef77c79.png";